import React, { useContext, useEffect, useState } from 'react';
import * as yup from 'yup';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const BankInfoContext = React.createContext(null);

const { Provider } = BankInfoContext;
export const BankInfoProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}